<div fxLayout="column" fxFlex="grow">
  <h2 class="head-title mb-0">{{ 'voicemail.title'| translate }}</h2>
  <div class="filter-container">
    <form [formGroup]="filterForm">
      <ng-container *ngIf="filtersReadonly;else BlockFormFilter">
        <div fxLayout="column" align="center">
          <span *ngIf="filterForm.get('start_dt').value && filterForm.get('end_dt').value">
            {{filterForm.get('start_dt').value | timeFormatDateShort }} --&gt; {{filterForm.get('end_dt').value |
            timeFormatDateShort}}
          </span>
          <span *ngIf="filterForm.get('listen_state').value !== ''">
            <strong>{{ 'recording_call.table_filter.listen_state'|translate }}</strong>:
            {{ filterForm.get('listen_state').value == 0 ?
            ('recording_call.table_filter.listen_state_unlistened' | translate) :
            ('recording_call.table_filter.listen_state_listened' | translate)
            }}
          </span>
          <span *ngIf="filterForm.get('calling_number').value">
            <strong>{{ 'voicemail.calling_number'|translate }}</strong>: {{filterForm.get('calling_number').value}}
          </span>
          <span *ngIf="filterForm.get('groups').value.length">
            <strong>{{ 'stats.filter.group'|translate }}</strong>: {{
            rendererGroup(filterForm.get('groups').value)|truncateArray }}
          </span>
          <span *ngIf="filterForm.get('queues').value.length">
            <strong>{{ 'stats.filter.queue'|translate }}</strong>: {{
            rendererQueue(filterForm.get('queues').value)|truncateArray }}
          </span>
          <span *ngIf="filterForm.get('numbers').value.length">
            <strong>{{ 'did.content.number'|translate }}</strong>: {{
            rendererNumber(filterForm.get('numbers').value)|truncateArray }}
          </span>
          <span *ngIf="filterForm.get('archived').value !== ''">
            <strong data-ci="show_archived">{{ (filterForm.get('archived').value === true ?
              'public.show_list_item.archived_messages' : 'public.show_list_item.active_messages')|translate }}</strong>
          </span>
          <a class="link" (click)="changeFilter()">{{ 'public.change'|translate }}</a>
        </div>
      </ng-container>
      <ng-template #BlockFormFilter>
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" fxFlexFill>
          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'public.from'|translate }}</mat-label>
              <input matInput [matDatepicker]="startPicker" formControlName="start_dt"
                placeholder="{{ 'public.from'|translate }}">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>

              <mat-error *ngIf="filterForm.get('start_dt').invalid && filterForm.get('start_dt').touched"
                [flexFormControlError]="filterForm.get('start_dt')"></mat-error>
            </mat-form-field>
          </div>
          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'public.to'|translate }}</mat-label>
              <input matInput [min]="filterForm.get('start_dt').value" [matDatepicker]="endPicker"
                formControlName="end_dt" [min]="filterForm.get('start_dt').value"
                placeholder="{{ 'public.to'|translate}}">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>

              <mat-error *ngIf="filterForm.get('end_dt').invalid && filterForm.get('end_dt').touched"
                [flexFormControlError]="filterForm.get('end_dt')" [customMessages]="{
                  matDatepickerMin: 'filter_form.datepicker.date_value_cannot_lesser_than_min_value'|translate:{
                    min: filterForm.get('end_dt').errors && filterForm.get('end_dt').errors.matDatepickerMin ? (filterForm.get('end_dt').errors.matDatepickerMin.min |timeFormatDateShort) : ''
                  }
                }"></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" fxFlexFill>
          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'recording_call.table_filter.listen_state'|translate }}</mat-label>
              <mat-select placeholder="{{'recording_call.table_filter.listen_state'|translate}}"
                formControlName="listen_state">
                <mat-option value="">{{'recording_call.table_filter.listen_state_any' | translate}}</mat-option>
                <mat-option value="0">{{'recording_call.table_filter.listen_state_unlistened' | translate}}</mat-option>
                <mat-option value="1">{{'recording_call.table_filter.listen_state_listened' | translate}}</mat-option>
              </mat-select>
              <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'listen_state', false, '')"
                [disabled]="!filterForm.get('listen_state').value">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'voicemail.calling_number'|translate }}</mat-label>
              <input matInput placeholder="{{'voicemail.calling_number'|translate}}" formControlName="calling_number">
              <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'calling_number', false)"
                [disabled]="!filterForm.get('calling_number').value">
                <mat-icon>close</mat-icon>
              </button>

              <mat-error [flexFormControlError]="filterForm.get('calling_number')" [customMessages]="{
                invalidPhoneNumber: 'public.message.phone_number_invalid'|translate
              }"></mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" fxFlexFill>
          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'stats.filter.select_did'|translate }}</mat-label>
              <flex-select [placeholder]="'stats.filter.select_did'| translate" formControlName="numbers"
                [itemList]="filteredDidsMulti | async" [itemTemplate]="itemTemplate"
                [selectTriggerTemplate]="selectTriggerTemplate" [options]="filterDidsSelectOptions" [multiple]="true">
                <ng-template #selectTriggerTemplate let-selectedValue="selectedValue">
                  <div *ngIf="selectedValue?.length > 0" [matTooltip]="getNumbers(selectedValue)">
                    <ng-container *ngFor="let selectedItem of selectedValue; let last=last">
                      <span country-flag *ngIf="selectedItem.country_code"
                        [countryCode2]="selectedItem.country_code"></span>
                      {{ selectedItem.number_with_name }}
                      <ng-container *ngIf="!last">, </ng-container>
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template #itemTemplate let-item="item">
                  <span country-flag *ngIf="item.country_code" [countryCode2]="item.country_code"></span>
                  {{ item.number_with_name }}
                </ng-template>
              </flex-select>
              <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'numbers', true)"
                [disabled]="!filterForm.get('numbers').value || !filterForm.get('numbers').value.length">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div fxFlex class="filter-item">
            <mat-form-field class="full-width">
              <mat-label>{{ 'stats.filter.select_queue'|translate }}</mat-label>
              <flex-select-queue-input [limitedByRole]="true" [showCheckAll]="true" [groupIds]="groupsControl.value"
                [multiple]="true" queueType="inbound" placeholder="{{ 'stats.filter.select_queue' | translate }}"
                formControlName="queues"></flex-select-queue-input>
              <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'queues', true)"
                [disabled]="!filterForm.get('queues').value || !filterForm.get('queues').value.length">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start" fxLayoutAlign="start center" fxLayoutGap="5px">
          <div fxFlex="50" class="filter-item" *ngIf="hasFeatureGroup">
            <mat-form-field class="full-width">
              <mat-label>{{ 'stats.filter.select_group'|translate }}</mat-label>
              <flex-select-group-input [limitedByRole]="true" [showCheckAll]="true" [multiple]="true"
                placeholder="{{ 'stats.filter.select_group' | translate }}" groupType="service"
                formControlName="groups">
              </flex-select-group-input>
              <button mat-icon-button matSuffix type="button" (click)="clearValue($event, 'groups', true)"
                [disabled]="!filterForm.get('groups').value || !filterForm.get('groups').value.length">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div [fxFlex]="hasFeatureGroup ? 50 : 100" class="filter-item">
            <mat-slide-toggle formControlName="archived"
              [matTooltip]="'public.show_list_item.archived_messages'|translate">
              {{ 'public.show_list_item.archived_messages'|translate }}
            </mat-slide-toggle>
          </div>
        </div>
        <div class="text-center">
          <button mat-raised-button color="accent" (click)="reloadClick()" class="button-show">{{ 'public.apply' |
            translate }}</button>
        </div>
      </ng-template>
    </form>
  </div>
  <div class="filter-container" *ngIf="unlistened_number">
    <h3>
      <strong>{{ 'voicemail.voicemail_unlisten' | translate:{ number_unlisten: unlistened_number } }}</strong>
    </h3>
  </div>
  <div fxFlex="grow">
    <flex-table [noHeader]="true" fxFill fxFlex [dataSource]="dataSource" [tableConfig]="tableConfig"
      [columnTemplates]="{voicemail: tplVoicemailInfo}">

      <ng-template #tplIcon let-item="row">
        <div fxFlexFill fxLayout="row" fxLayoutAlign="center center">
          <mat-icon [color]="item.is_read ? '': 'warn'">voicemail</mat-icon>
        </div>
      </ng-template>

      <ng-template #tplVoicemailInfo let-item="row" let-is_selected="is_selected">
        <div fxLayout="column" class="full-width">
          <div fxLayout="row">
            <div fxFlex="40px">
              <ng-container *ngTemplateOutlet="tplIcon; context: {row: item}"></ng-container>
            </div>

            <div fxFlex fxLayout="column" fxLayoutAlign="start start">
              <h3 class="mb-0 is-missed" [ngClass]="{'font-weight-bold': !item.is_read}">
                <span>{{ item.calling_number | displayPhoneNumber }}</span>
                <ng-container *ngIf="item.client_name">&nbsp;
                  <span
                    *ngIf="(item.client_name.length == 25 || item.client_name.length < 25);else BlockToolTipClientName">
                    ({{ item.client_name }})
                  </span>
                  <ng-template #BlockToolTipClientName>
                    <span [matTooltip]="item.client_name">({{ item.client_name | truncate }})</span>
                  </ng-template>
                </ng-container>
                <span> -&gt; {{ item.called_number | displayPhoneNumber }}</span>
              </h3>
              <p class="mat-text-muted mb-0 mt-0 text-md queue-name" [ngClass]="{'font-weight-bold': !item.is_read}">
                <ng-container *ngIf="item.queue_name;else BlockPersonalCall">
                  <span [matTooltip]="item.queue_name">{{ item.queue_name|truncate:35 }}</span>
                </ng-container>
                <ng-template #BlockPersonalCall>
                  {{ 'voicemail.personal'|translate }}
                </ng-template>
              </p>

            </div>

            <div fxFlex="90px" fxLayoutAlign="end start">
              <ng-container *ngTemplateOutlet="tplReceivedDate; context: {row: item}"></ng-container>
            </div>
          </div>

          <ng-container *ngTemplateOutlet="tplActions; context: {row: item, is_selected: is_selected}"></ng-container>

        </div>
      </ng-template>

      <ng-template #tplReceivedDate let-item="row">
        <div class="mat-text-muted text-md full-width" fxLayout="column" fxlayoutalign="start start">
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon-row">date_range</mat-icon>
            <span>{{ item.receive_dt|dateInbox:'dateOnly' }}</span>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="icon-row">access_time</mat-icon>
            <span>{{ item.receive_dt | date : 'HH:mm:ss' }}</span>
          </div>
        </div>
      </ng-template>

      <ng-template #tplActions let-item="row" let-is_selected="is_selected">
        <div *ngIf="is_selected" class="full-width" fxLayout="row" fxLayoutAlign="center center">
          <div fxFlex class="text-center" *ngIf="canMakeCall()">
            <button class="button-detail" type="button" mat-icon-button color="primary" (click)="makeCall(item)"
              [matTooltip]="'call.actions.make_call'|translate">
              <mat-icon>phone</mat-icon>
            </button>
          </div>
          <div fxFlex class="text-center">
            <button class="button-detail" type="button" mat-icon-button color="primary" (click)="archiveVoicemail(item)"
              [matTooltip]="'voicemail.action.archive'|translate" *ngIf="!item.is_archived; else tplUnarchiveVoicemail">
              <mat-icon>archived</mat-icon>
            </button>
            <ng-template #tplUnarchiveVoicemail>
              <button class="button-detail" type="button" mat-icon-button color="primary"
                (click)="unarchiveVoicemail(item)" [matTooltip]="'voicemail.action.unarchive'|translate">
                <mat-icon>unarchived</mat-icon>
              </button>
            </ng-template>
          </div>
          <div fxFlex class="text-center">
            <span class="voicemail-player">
              <span class="voicemail-unread-mask" *ngIf="item.sound_id && !item.is_read"></span>
              <fileentry-player-button [disabled]="!item.sound_id" [filePublicId]="item.sound_id" lang=""
                (onPlay)="updateListened(item)" [matTooltip]="'voicemail.action.play_message'|translate">
              </fileentry-player-button>
            </span>
          </div>
        </div>
      </ng-template>
    </flex-table>
  </div>
</div>
